module.exports = __webpack_public_path__ + "img/no-result.391c317f.svg";